export default "__VITE_PUBLIC_ASSET__3308ac6c__"